import React from 'react';
import FavoriteItem from '../components/FavoriteItem';
import { useSelector } from 'react-redux';

const Favorites = () => {


const favItems = useSelector(state => state.favorite.favoriteItem);

  return (
    <div className='container m-auto lg:px-10 px-4'>
    <h1 className='lg:text-3xl text-xl font-bold my-3 lg:pb-6 pb-2'>Favorite List</h1>
      {favItems.map((item) => {
        return(
          <FavoriteItem key={item.id} id={item.id} image={item.image} title={item.title} price={item.price}/>
          );
      })}


       {(favItems.length == 0) && <p className='text-xl mb-9'>Favorite List are Empty </p>}

    </div>
  )
}

export default Favorites